var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortraitLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 1403 227.2",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#1d1b19"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,227.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7880.86,1680.64 7187.96,35.0195 h 89.87 L 7843.49,1395.22 8196.57,544.898 h -545.68 v -63.019 h 571.85 L 8408.29,35.0195 h 234.68 L 7941.55,1680.64 h -60.69",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 826.32,1615.29 c -85.601,35.78 -186.738,53.69 -303.453,53.69 H 0 V 35.0195 H 207.746 V 1608.29 h 273.106 c 121.382,0 216.281,-33.08 284.777,-99.21 68.461,-66.15 102.707,-152.88 102.707,-260.26 0,-71.59 -15.176,-134.21 -45.52,-187.91 -30.347,-53.68 -75.097,-95.699 -134.214,-126.051 -59.161,-30.336 -128.391,-45.511 -207.75,-45.511 h -98.985 v -60.684 h 141 c 116.715,0 217.852,17.496 303.453,52.512 85.563,35.019 150.918,84.398 196.08,148.214 45.11,63.81 67.69,136.93 67.69,219.43 0,82.46 -22.58,155.22 -67.69,218.25 -45.162,63.02 -110.517,112.4 -196.08,148.22",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2582.77,426.012 C 2529.09,310.059 2456.33,222.121 2364.53,162.238 2272.69,102.309 2168.45,72.3711 2051.74,72.3711 c -116.71,0 -220.99,29.9379 -312.79,89.8669 -91.83,59.883 -164.56,147.821 -218.25,263.774 -53.68,115.91 -80.53,257.918 -80.53,425.984 0,168.074 26.85,310.054 80.53,426.004 53.69,115.9 126.42,203.85 218.25,263.77 91.8,59.88 196.08,89.86 312.79,89.86 116.71,0 220.95,-29.98 312.79,-89.86 91.8,-59.92 164.56,-147.87 218.24,-263.77 53.69,-115.95 80.54,-257.93 80.54,-426.004 0,-168.066 -26.85,-310.074 -80.54,-425.984 z M 2485.9,1593.11 c -127.61,73.91 -272.33,110.88 -434.16,110.88 -163.4,0 -308.92,-36.97 -436.5,-110.88 -127.62,-73.93 -227.22,-175.46 -298.78,-304.6 -71.6,-129.19 -107.37,-274.67 -107.37,-436.514 0,-161.855 35.77,-307.348 107.37,-436.496 71.56,-129.191 171.16,-230.73 298.78,-304.621 C 1742.82,36.9492 1888.34,0 2051.74,0 c 161.83,0 306.55,36.9492 434.16,110.879 127.58,73.891 227.19,175.43 298.79,304.621 71.55,129.148 107.37,274.641 107.37,436.496 0,161.844 -35.82,307.324 -107.37,436.514 -71.6,129.14 -171.21,230.67 -298.79,304.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8815.51,35.0195 h 207.75 V 1668.98 H 8815.51 V 35.0195",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3951.22,912.695 c 84.8,32.672 150.16,78.563 196.07,137.715 45.89,59.13 68.86,130.72 68.86,214.75 0,79.36 -22.57,149.75 -67.69,211.25 -45.16,61.45 -109.71,108.9 -193.74,142.38 -84.03,33.45 -183.64,50.19 -298.79,50.19 H 3126.06 V 35.0195 h 207.75 V 1608.29 h 282.44 c 118.25,0 210.85,-29.99 277.78,-89.87 66.89,-59.92 100.37,-145.88 100.37,-257.93 0,-76.26 -15.17,-140.46 -45.52,-192.57 -30.35,-52.17 -73.93,-91.842 -130.71,-119.053 -56.83,-27.234 -124.12,-40.84 -201.92,-40.84 H 3507.8 V 863.672 L 4132.12,35.0195 h 263.09 L 3749.8,868.297 c 74.86,6.875 142.11,21.551 201.42,44.398",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6655.31,912.695 c 84.8,32.672 150.16,78.563 196.08,137.715 45.88,59.13 68.85,130.72 68.85,214.75 0,79.36 -22.57,149.75 -67.69,211.25 -45.15,61.45 -109.71,108.9 -193.74,142.38 -84.03,33.45 -183.64,50.19 -298.78,50.19 H 5830.16 V 35.0195 H 6037.9 V 1608.29 h 282.45 c 118.24,0 210.84,-29.99 277.77,-89.87 66.89,-59.92 100.37,-145.88 100.37,-257.93 0,-76.26 -15.17,-140.46 -45.51,-192.57 -30.35,-52.17 -73.94,-91.842 -130.72,-119.053 -56.82,-27.234 -124.12,-40.84 -201.91,-40.84 H 6211.89 V 863.672 L 6836.21,35.0195 h 263.1 L 6453.89,868.297 c 74.87,6.875 142.11,21.551 201.42,44.398",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4322.16,1605.95 h 546.2 V 35.0195 h 207.75 V 1605.95 h 543.88 v 63.03 H 4322.16 v -63.03",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9224.62,1668.98 v -63.03 h 546.21 V 35.0195 h 207.75 V 1605.95 h 543.92 v 63.03 H 9224.62",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitLogo);
export default __webpack_public_path__ + "static/media/portrait-logo.d63c5fa4.svg";
export { ForwardRef as ReactComponent };